import React from "react";
import { WalletCards } from "lucide-react";

const BillingSettingsIcon = (props: any) => <WalletCards {...props} />;

export default BillingSettingsIcon;
